// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'square-solid';

export const Component = () => (
  <path d='M19.752 6.485v11.781c0 .432-.144.767-.432 1.054a1.408 1.408 0 0 1-1.054.432H6.486a1.41 1.41 0 0 1-1.055-.432A1.408 1.408 0 0 1 5 18.266V6.486c0-.432.144-.767.431-1.055A1.408 1.408 0 0 1 6.485 5h11.781c.432 0 .767.144 1.054.431.288.288.432.623.432 1.054Z' />
);

export const viewBox = '0 0 25 25';
